import { maskPhone } from "@/common/helpers/mask.helpers";
import {
  settingAge,
  formatDateNoHours,
} from "../../../../common/helpers/date.helpers";
import { formatGender } from "../../../../common/helpers/text.helpers";

export function personalLeadInfo(lead) {
  return [
    {
      id: lead._id,
      spanSize: "col-span-1",
      label: "WhatsApp",
      value: maskPhone(lead.whatsapp),
    },
    { id: 2, spanSize: "col-span-1", label: "Nome", value: lead.name },
    { id: 3, spanSize: "col-span-1", label: "E-mail", value: lead.email },
    {
      id: 4,
      spanSize: "col-span-1",
      label: "Gênero",
      value: formatGender(lead.gender),
    },
    {
      id: 5,
      spanSize: "col-span-1",
      label: "Nome da mãe",
      value: lead.motherName,
    },
    {
      id: 6,
      spanSize: "col-span-1",
      label: `Data de nascimento (${settingAge(
        formatDateNoHours(lead.birthDate)
      )} anos)`,
      value: formatDateNoHours(lead.birthDate),
    },
    {
      id: 7,
      spanSize: "col-span-1",
      label: "Estado civil",
      value: lead.maritalStatus,
    },
    { id: 8, spanSize: "col-span-1", label: "CPF", value: lead.cpf },
    {
      id: 9,
      spanSize: "col-span-1",
      label: "Tipo sanguíneo",
      value: lead.typeSanguine,
    },
    { id: 10, spanSize: "col-span-1", label: "CNH", value: lead.cnh },
    {
      id: 11,
      spanSize: "col-span-1",
      label: "Vencimento CNH",
      value: formatDateNoHours(lead.cnhExpirationDate),
    },
    {
      id: 12,
      spanSize: "col-span-1",
      label: "Categoria da CNH",
      value: lead.categoryCNH,
    },
    { id: 13, spanSize: "col-span-1", label: "RG", value: lead.rg },
    {
      id: 14,
      spanSize: "col-span-1",
      label: "Orgão expedidor",
      value: lead.rg_orgexp,
    },
    {
      id: 15,
      spanSize: "col-span-1",
      label: "Origem do Lead",
      value: lead.leadOrigin,
    },
    {
      id: 15,
      spanSize: "col-span-1",
      label: "Consultor",
      value: lead.technicalConsultant,
    },
    {
      id: 15,
      spanSize: "col-span-1",
      label: "Representante de vendas (SDR)",
      value: lead.sdr,
    },
    {
      id: 15,
      spanSize: "col-span-1",
      label: "CPF da pessoa que o(a) indicou",
      value: lead.cpfDoIndicador,
    },
  ];
}
export function leadAddressInfo(lead) {
  return [
    {
      id: 1,
      spanSize: "col-span-1",
      label: "CEP",
      value: lead.address?.zipcode,
    },
    {
      id: 2,
      spanSize: "col-span-2",
      label: "Endereço",
      value: lead.address?.street,
    },
    {
      id: 3,
      spanSize: "col-span-1",
      label: "Número",
      value: lead.address?.number,
    },
    {
      id: 4,
      spanSize: "col-span-2",
      label: "Complemento",
      value: lead.address?.complement,
    },
    {
      id: 5,
      spanSize: "col-span-1",
      label: "Estado",
      value: lead.address?.state,
    },
    {
      id: 6,
      spanSize: "col-span-1",
      label: "Cidade",
      value: lead.address?.city,
    },
    {
      id: 7,
      spanSize: "col-span-1",
      label: "Bairro",
      value: lead.address?.district,
    },
  ];
}
